import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Menu, MenuItem,
} from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import MenuIcon from '@mui/icons-material/Menu';
import useSiteHeaderStyle from '../styles/SiteHeaderStyles.jsx';
import NavButton from './NavButton.jsx';

const SiteHeader = ({ toggleTheme, isMobile, theme }) => {
  const classes = useSiteHeaderStyle();
  const navs = ['About', 'Portfolio', 'Gallery'];
  const [hovered, setHovered] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const hoverToggleOn = () => {
    setHovered(true);
  };

  const hoverToggleOff = () => {
    setHovered(false);
  };

  return (
    <Box>
      <Box className={classes.root}>
        <Box className={classes.home}>
          <Brightness4Icon
            fontSize='medium'
            color='inherit'
            onClick={toggleTheme}
            onMouseEnter={hoverToggleOn}
            onMouseLeave={hoverToggleOff}
            className={hovered ? classes.themeToggle : ''}
          />{' | '}
          <NavButton text={'HELLO FROM TINGJUN!'} />
        </Box>
        {!isMobile
          && <Box className={classes.navigation}>
            {navs.map(nav => <NavButton key={nav} text={nav} />)}
          </Box>
        }

        {isMobile
          && <Box className={classes.menu}>
            <MenuIcon
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              color='inherit'
              fontSize='large'
            >
            </MenuIcon>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              color='inherit'
              PaperProps={{ sx: { width: '100vw', background: theme === 'light' ? '#F2F5F9' : '#424344', color: theme !== 'light' && 'white' } }}
              disableAutoFocusItem
            >

              {navs.map(
                nav => <MenuItem
                  key={nav}
                  onClick={handleClose}
                  className={classes.navMenu}
                >
                  <NavButton text={nav} />
                </MenuItem>,
              )}
            </Menu>
          </Box>
        }
      </Box>
    </Box>
  );
};

SiteHeader.propTypes = {
  toggleTheme: PropTypes.func,
  isMobile: PropTypes.bool,
  theme: PropTypes.string,
};
export default SiteHeader;
